<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("state", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("state_dash_msg") }}</div>
      </div>
      <div v-if="$can('create', 'States')">
        <b-button variant="default" to="add-state" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
   <div class="d-flex justify-content-start">
    <div>
        <b-form-input
          v-debounce:300="getStatesList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
     
      <div class="ml-3" style="width: 250px;">
        <div class="dropdown-curve-container">
              <label :class="selectedCountry && selectedCountry.country_id ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("country", 1) }}</label
              >
              <multiselect
                :options="countryList"
                v-model="selectedCountry"
                :searchable="true"
                label="country_name"
                track-by="country_id"
                placeholder="Select Country"
                @input="onChangeCountry($event)"
                :allowEmpty="false"
                :showLabels="false"
                :clearable="true"
              ></multiselect>
            </div>
      </div>
      <button @click="onClear" class="btn-blue ml-3">Clear</button>
   </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing &nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="States.length > 0"
        v-for="(item, key) in States"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.state_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'States')"
                  @click="goToRoute('/master/edit-state', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/master/view-state', item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot
                :status="item.state_is_active ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="States.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 400px">
            <img
              v-if="this.columnName != 'state_name'"
              @click="onSortValue('state_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('state_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('state_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("state", 1) }}
          </th>
          <th style="width: 200px; text-align: center">
            <img
              v-if="this.columnName != 'state_code'"
              @click="onSortValue('state_code', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('state_code', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('state_code', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("state", 1) }} {{ $tc("Code", 1) }}
          </th>
          <th>{{ $tc("country", 1) }}</th>
        </tr>
      </thead>
      <tbody v-if="States.length > 0">
        <tr v-for="(item, key) in States" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.state_is_active ? 'active' : 'inactive'"
              />
              <div
                v-if="$can('update', 'States')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/master/edit-state', item)"
                v-b-tooltip="'Edit'"
                tabindex="0"
                style="cursor: pointer"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
              <div
                class="clickable-icon ml-2"
                @click="goToRoute('/master/view-state', item)"
                v-b-tooltip="'View'"
                tabindex="0"
                style="cursor: pointer"
              >
                <i class="icon-eye icon blue-icon"></i>
              </div>
            </div>
          </td>

          <td>{{ $tc(item.state_name, 1) }}</td>
          <td class="text-center">
            {{ item.state_code ? item.state_code : "-" }}
          </td>
          <td>{{ item.country_name?item.country_name:"-" }}</td>
        </tr>
      </tbody>
      <tbody v-if="States.length == 0">
        <tr>
          <td colspan="2">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-if="States.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import States from "@/helper/formJSONMaster/States";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: States.Methods,
      States: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "state_name",
      countryList: [],
      countryListCopy:[],
      searchCountry: "",
      selectedCountry:null,
      selectedCountry_id:null

    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    this.getStatesList();
    this.getCountryList();
    this.getviewingnumber();
  },
  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getStatesList();
      } else {
        this.currentPage = event;
        this.getStatesList();
      }
    },

    goToRoute: function (path, item) {
      const { state_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: state_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {

      if(this.columnName === columnName){
        this.isAscending = !this.isAscending;
      }else{
        this.isAscending = orderby === 'asc' ? true : false;
      }
      this.isSort = true;
      // this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getStatesList();
    },
    getStatesList: function () {
      this.States = [];
      // let body = this.getRequestBody("GET", undefined, this.Methods);
      // body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&searchValue=${this.searchValue}&searchKey=${this.searchKey}`;
      let payload={
        limit:this.perPage,
        currentPage:this.currentPage,
        orderBy:this.orderby,
        searchValue:this.searchValue,
        columnName:this.columnName,
      }
   // Check if selectedCountry is valid and has the country_id property
  // if (this.selectedCountry && this.selectedCountry.hasOwnProperty("country_id")) {
    if (this.selectedCountry_id) {

    console.log("selectedCountry =>", this.selectedCountry);
    payload.country_id = this.selectedCountry_id;
  } else {
    console.warn("selectedCountry is undefined or does not have country_id");
  }
      MasterService.getStateDataWithCountry(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.States = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCountryList: function (value, index) {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_countries",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.countryList = data.Records;
            this.countryListCopy = data.Records;
            let array = this.countryList.filter((x) => x.country_id === value);
            if (value && index && array.length > 0) {
              this.States[index].dropdownSelected = array[0].country_name;
            }
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },

    onSearchCountry:function(){
      if (this.searchCountry) {
        this.countryList = this.countryListCopy.filter((x) => {
          if (
            x.country_name
              .toLowerCase()
              ==this.searchCountry.toLowerCase()
          ) {
            return x;
          }
        });
      } else {
        this.countryList = this.countryListCopy;
      }
    },
    onChangeCountry:function(item){
      console.log("item->",item.country_id)
      this.selectedCountry=item;
      this.selectedCountry_id=item.country_id
      this.getStatesList()
    },
    onClear: function () {
  this.searchValue = "";
  this.selectedCountry = null;
  this.selectedCountry_id = null;

  // Force reactivity (if needed)
  this.$nextTick(() => {
    this.getStatesList();
  });
},

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/StatesComponents/states.vue